module.exports = __webpack_public_path__ + "static/media/show-tab.e7f51043.png";